import { useEffect, useMemo, useState } from 'react';
import { useForm } from 'react-hook-form-mui';

import { useGetInvoiceData, useUpdateInvoiceData } from 'src/use-cases/internalDashboard/useFileResolution';
import { InvoiceMessageDto } from 'src/generated/services/TFinancialApi';
import { ROW_ACTION_TYPE, TUpdateValues } from './types';
import { ModalUpdateBase } from './ModalUpdateBase';
import { FormEditInvoiceData } from './FormEditInvoiceData.tsx';
import { useInternalDashboardSelector } from './Selector';
import { openToastError } from '../../../../use-cases/toast/useToast.tsx';

const actionType = ROW_ACTION_TYPE.EDIT_INVOICE;
const defaultValues = {
  invoiceData: '',
};

export const ModalEditInvoice = () => {
  const formContext = useForm({
    defaultValues: defaultValues as TUpdateValues,
  });

  const [ocrMessage, setOcrMessage] = useState<string>('');
  const { selectedRow, rowActionType, setIsActionLoading, stopRowAction, checkRowAction, filterParams } = useInternalDashboardSelector();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const isOpen = useMemo(() => checkRowAction(actionType), [rowActionType]);

  const { data } = useGetInvoiceData(selectedRow?.invoiceFileProcessingId, isOpen);

  useEffect(() => {
    if (data?.message) {
      setOcrMessage(JSON.stringify(data?.message, null, 2));
    } else {
      setOcrMessage('');
    }
  }, [data, setOcrMessage]);

  const { mutateAsync: update } = useUpdateInvoiceData();

  const onSubmitForm = async (values: TUpdateValues) => {
    setIsActionLoading(true);

    try {
      await update({
        invoiceFileProcessingId: selectedRow?.invoiceFileProcessingId,
        data: JSON.parse(values.invoiceData || {}) as InvoiceMessageDto,
        params: filterParams,
      });
    } catch (error) {
      if (error instanceof Error) {
        openToastError(error);
      } else {
        openToastError(new Error('An unknown error occurred'));
      }
      setIsActionLoading(false);
      return;
    }

    setIsActionLoading(false);
    stopRowAction();
  };

  return (
    <ModalUpdateBase title='Edit Invoice Data' actionType={actionType} formContext={formContext} onSubmit={onSubmitForm}>
      <div className='relative'>
        <FormEditInvoiceData ocrMessage={ocrMessage} />
      </div>
    </ModalUpdateBase>
  );
};
